import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { isDemoMode } from '../demo/core';

export interface KPILimit {
  id: string;
  name: string;
  value: number;
  operator: '>' | '<' | '=' | '>=' | '<=';
  alertMessage: string;
  isEnabled: boolean;
}

interface KPIStore {
  limits: KPILimit[];
  addLimit: (limit: KPILimit) => void;
  updateLimit: (id: string, limit: Partial<KPILimit>) => void;
  removeLimit: (id: string) => void;
  toggleLimit: (id: string) => void;
}

export const useKPIStore = create<KPIStore>()(
  persist(
    (set) => ({
      limits: [],
      addLimit: (limit) =>
        set((state) => ({
          limits: [...state.limits, limit],
        })),
      updateLimit: (id, limit) =>
        set((state) => ({
          limits: state.limits.map((l) =>
            l.id === id ? { ...l, ...limit } : l
          ),
        })),
      removeLimit: (id) =>
        set((state) => ({
          limits: state.limits.filter((l) => l.id !== id),
        })),
      toggleLimit: (id) =>
        set((state) => ({
          limits: state.limits.map((l) =>
            l.id === id ? { ...l, isEnabled: !l.isEnabled } : l
          ),
        })),
    }),
    {
      name: 'kpi-limits',
      // Demo tabs keep limits per tab: they reset on reload and never reach a real session.
      storage: createJSONStorage(() => (isDemoMode() ? sessionStorage : localStorage)),
    }
  )
); 